import { render, staticRenderFns } from "./drawerBox.vue?vue&type=template&id=352b1e53&scoped=true"
import script from "./drawerBox.vue?vue&type=script&lang=js"
export * from "./drawerBox.vue?vue&type=script&lang=js"
import style0 from "./drawerBox.vue?vue&type=style&index=0&id=352b1e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b1e53",
  null
  
)

export default component.exports